import React from "react";
import { deleteMedia, listMedia } from "/@src/redux/media/actions";
import { useDispatch } from "react-redux";
import { closeModal } from "/@src/redux/modal/actions";
import { Button } from "reactstrap";
import IntlMessages from "/@src/helpers/IntlMessages";

function DeleteMedia({ media }) {
  const dispatch = useDispatch();
  const deleteMediaConfirmed = () => {
    dispatch(deleteMedia(media.mediaId)).then(() => {
      dispatch(closeModal("delete-media"));
      dispatch(listMedia());
    });
  };
  return (
    <>
      <div>
        <h2 className="mb-4">Are you sure?</h2>
        <p>
          File: <b>{media.fileName}</b>
        </p>
        <p>
          This action is irreversible. Please ensure that no projects are using
          this media.
        </p>
      </div>

      <div className="mt-4 top-right-button-container">
        <Button
          color="danger"
          outline
          className="btn-lg"
          onClick={deleteMediaConfirmed}
        >
          <IntlMessages id="button.delete" />
        </Button>
      </div>
    </>
  );
}

export default DeleteMedia;
